// create user reducer
import { GET_ALL_CLIENTS_REQUEST, GET_ALL_CLIENTS_SUCCESS, GET_ALL_CLIENT_FAIL, GET_CLIENT_FAIL, GET_CLIENT_REQUEST, GET_CLIENT_SUCCESS } from "../types/mobileFinnance";

const initialState = {
    // acounts: null,
    client: null, 
    singleClient:null,
    success:true,
    loading: false,
    error: null,
};
const client = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_CLIENTS_REQUEST:
            return {
                ...state,
                loading: false,
                success:false,
                error:null,
            };
        case GET_ALL_CLIENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                client: action.payload,
                error:null,
                success:true
            };

        case GET_ALL_CLIENT_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success:false
            };
            
            case GET_CLIENT_REQUEST:
                return {
                    ...state,
                    loading: false,
                    success:false,
                    error:null,
                    singleClient:null
                    
                    
                };
                case GET_CLIENT_SUCCESS:
                    return {
                        ...state,
                        loading: false,
                        singleClient: action.payload,
                        error:null,
                        success:true
                    };
                    case GET_CLIENT_FAIL:
                        return {
                            ...state,
                            loading: false,
                            error: action.payload,
                            success:false
                        };

        default:
            return state;
    }
};

export default client;